export default function propsProvider(props) {
  /*
      - To only list utilized props
      - Wrapping utilized props on each view
  */
  const { intl, articleList, openInNewTab, history, productInfo } = props;
  return { intl, articleList, openInNewTab, history, productInfo };
}
